import React from 'react';
import Highcharts from 'highcharts';
import Highmaps from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
import wordcloud from 'highcharts/modules/wordcloud';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import solidGauge from 'highcharts/modules/solid-gauge';
import highchartsMore from 'highcharts/highcharts-more';

wordcloud(Highcharts);
exporting(Highcharts);
exportData(Highcharts);
highchartsMore(Highcharts); // required by solidGauge
solidGauge(Highcharts);

const dataLabels = {
    style: {
        color: '#343940',
        font: '"Work Sans", sans-serif',
        fontSize: '11px',
        textOutline: null,
    },
};

Highcharts.theme = {
    chart: {
        spacing: [30, 30, 30, 30],
    },
    colors: ['#119BD6', '#F9C717', '#E8617F', '#FB8D2D', '#B6B6B5', '#79E861'],
    credits: {
        enabled: false,
    },
    title: {
        style: {
            color: '#343940',
            font: 'bold 16px "Work Sans", sans-serif',
            alignment: 'right',
        },
        align: 'left',
    },
    yAxis: {
        labels: {
            style: {
                color: '#343940',
                font: '12px "Work Sans", sans-serif',
            },
        },
    },
    xAxis: {
        labels: {
            style: {
                color: '#343940',
                font: '600 12px "Work Sans", sans-serif',
            },
        },
    },
    plotOptions: {
        pie: {dataLabels: {...dataLabels}},
        column: {dataLabels: {...dataLabels}},
        bar: {dataLabels: {...dataLabels}},
    },
    tooltip: {
        backgroundColor: '#4D4C4C',
        borderColor: '#4D4C4C',
        shadow: false,
        headerFormat: '<span />',
        pointFormat: '<span>{point.y}</span>',
        style: {
            color: '#fff',
            fontWeight: '600',
            fontSize: '12px',
            font: '"Work Sans", sans-serif',
        },
    },
};

Highcharts.setOptions(Highcharts.theme);
Highmaps.setOptions(Highcharts.theme);

const Chart = React.forwardRef(({map, children, ...props}, ref) => (
    <div className="chart" ref={ref}>
        {children}
        <HighchartsReact highcharts={map ? Highmaps : Highcharts} {...props} />
    </div>
));

Chart.displayName = 'Chart';

export default Chart;
